import { render, staticRenderFns } from "./RoleDetail.vue?vue&type=template&id=6e0de2cd&scoped=true"
import script from "./RoleDetail.vue?vue&type=script&lang=js"
export * from "./RoleDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0de2cd",
  null
  
)

export default component.exports